import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import Context from '@s-ui/react-context'
import {useLocation} from '@s-ui/react-router'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {ROUTES} from '../../../../../config/index.js'
import {useUtils} from '../../utils/useUtils.js'
import UserFormSection from './UserFormSection.js'
import UserWelcomeSection from './UserWelcomeSection.js'

const DEFAULT_LITERAL_DESCRIPTION = 'RESERVATION_C2B.USER_FORM.FORM_DESCRIPTION'
const DEFAULT_LITERAL_TITLE = 'RESERVATION_C2B.USER_FORM.TITLE'

const PURCHASE_LITERAL_DESCRIPTION = 'USER_PROFILE.COMPLETE.SAFE_PURCHASE_C2C.DESCRIPTION'
const PURCHASE_LITERAL_TITLE = 'COMMON.COMPLETE_DATA'

const UserForm = ({userData}) => {
  const {pathname} = useLocation()

  const isPurchaseFlow = pathname === ROUTES.USER.PROFILE_COMPLETE.PURCHASE

  const {i18n} = useContext(Context)
  const {getFormData} = useUtils()

  const literalDescription = isPurchaseFlow ? PURCHASE_LITERAL_DESCRIPTION : DEFAULT_LITERAL_DESCRIPTION
  const literalTitle = isPurchaseFlow ? PURCHASE_LITERAL_TITLE : DEFAULT_LITERAL_TITLE

  return (
    <div className="mt-UserProfileComplete-main">
      <div className="mt-UserProfileComplete-userForm">
        <TitleBasic
          as={titleBasicTags.h2}
          color={titleBasicColors.black}
          size={titleBasicSizes.s}
          title={i18n.t(literalTitle)}
        />
        <p>
          {htmlStringToReactElement(
            i18n.t(literalDescription, {
              strongStart: '<strong>',
              strongEnd: '</strong>'
            })
          )}
        </p>
        <UserWelcomeSection userData={userData} />
        <UserFormSection userData={getFormData(isPurchaseFlow, userData)} />
      </div>
      <div className="mt-UserProfileComplete-side">
        <UserWelcomeSection userData={userData} />
      </div>
    </div>
  )
}

UserForm.displayName = 'UserForm'
UserForm.propTypes = {
  userData: PropTypes.object
}

export default UserForm
